import type { AnalyticsFiltersGroup } from '../../../../analyticsModule/components/AnalyticsFilterSelect/AnalyticsFiltersSelect.types'
import type { AnalyticsDataDecorationOverrides, AnalyticsFilters } from '../../../../types'

type FilterGroup = AnalyticsFilters[0]
type Filter = FilterGroup['filters'][0]

export const getDecorationOverridesFromFilterGroup = (
  group: FilterGroup,
  currentFilters: AnalyticsFiltersGroup[],
): AnalyticsDataDecorationOverrides => {
  if (!group.filters) return []

  const overrides: AnalyticsDataDecorationOverrides = []

  group.filters.forEach((filter: Filter) => {
    if (
      filter.decoration_overrides &&
      currentFilters.some(
        (filterGroup) =>
          filterGroup.key === group.key &&
          filterGroup.items.some((item) => item.value === filter.key && item.checked),
      )
    ) {
      // Handle the case where decoration_overrides might be undefined
      const decorationOverrides = filter.decoration_overrides
      if (decorationOverrides) {
        overrides.push(...decorationOverrides)
      }
    }
  })

  return overrides
}
